export const settings = {
  title: "Settings",
  subtitle: "Manage your account security and preferences",
  language: {
    /** Section heading in the settings panel. */
    title: "Language",
    description: "Choose the language the app is displayed in. Your saved content stays in English.",
    label: "Display language",
    hint: "Applies immediately — no reload needed.",
    /** Announced to screen readers after a change. */
    changed: "Language set to {{language}}",
    learningContentNote:
      "Lyder Talk teaches English. Switching this changes the menus, buttons and instructions — not the topics or vocabulary you learn from.",
  },
  account: {
    pushNotifications: "Push Notifications",
    pushNotificationsDescription: "Get alerts when sessions are shared in your study groups",
    notEnabled: "Not enabled",
    blockedByBrowser: "Blocked by browser",
    enable: "Enable",
    requesting: "Requesting…",
    unblock: "Unblock in Browser",
    howToEnable: "How to enable notifications:",
    howToEnableSteps: [
      "Click the lock icon in your browser's address bar",
      "Find \"Notifications\" in the permissions list",
      "Change from \"Block\" to \"Allow\"",
      "Refresh this page",
    ],
    changeEmail: "Change Email",
    changeEmailDescription: "A verification email will be sent to confirm the change",
    currentEmail: "Current Email",
    newEmail: "New Email",
    newEmailPlaceholder: "New email address",
    confirmEmail: "Confirm Email",
    confirmEmailPlaceholder: "Confirm new email",
    passwordForConfirmation: "Enter your password to confirm",
    updateEmail: "Update Email",
    changing: "Changing…",
    changePassword: "Change Password",
    changePasswordDescription: "Keep your account secure with a strong password",
    currentPassword: "Current Password",
    currentPasswordPlaceholder: "Enter current password",
    newPassword: "New Password",
    newPasswordPlaceholder: "New password",
    confirmPassword: "Confirm Password",
    confirmPasswordPlaceholder: "Confirm password",
    updatePassword: "Update Password",
  },
  email: {
    title: "Email Notifications",
    description: "Sent to {{email}}",
    descriptionFallback: "Choose what Lyder Talk sends to your inbox",
    groupActivity: "Activity and comments",
    groupActivityDescription: "Shares, joins, topic picks, and comments on your sessions or in your study groups",
    reviewReminders: "Vocabulary review reminders",
    reviewRemindersDescription: "A short note when words are due, so nothing slips past its review date",
    weeklyDigest: "Weekly progress digest",
    weeklyDigestDescription: "One email each Monday with your sessions, words reviewed and what is due next",
    allOffTitle: "Notification emails are off",
    allOffDescription: "You unsubscribed from every notification email. Account emails still arrive.",
    resubscribe: "Turn emails back on",
    accountMailNote:
      "Password resets and email-change confirmations are account emails and are always sent.",
    saveError: "Could not save that preference",
    saveErrorDescription: "Please try again in a moment.",
    loading: "Loading email preferences…",
    unavailable: "Email preferences are unavailable right now. Your current settings are unchanged.",
  },
  profile: {
    title: "Profile",
    displayName: "Display name",
    bio: "Bio",
    avatar: "Avatar",
    save: "Save changes",
    saving: "Saving…",
    statistics: "Stats",
    /** Pane names, shared by the desktop rail and the mobile tab strip. */
    sections: "Settings",
    modalTitle: "Profile settings",
    fallbackName: "Learner",
  },
  /** The credentials + notifications pane of the profile dialog. */
  accountPanel: {
    title: "Account",
    blocked: "Blocked",
  },
} as const;